import { createSelector } from "@reduxjs/toolkit";

export const selectItemsDocsList = state => state.documents.itemsDocs;

export const selectPaymentDocsList = state => state.documents.paymentsDocs;

export const selectDetailedDoc = state => state.documents.detailedDoc;

export const selectUserCompaniesData = state =>
  state.documents.userCompaniesData;

export const selectPartsToDisplay = state => state.documents.partsToDisplay;

export const selectAllParts = state => state.documents.allParts;

export const selectPartsByLocation = state => state.documents.partsByLocation;

export const selectChosenLocationInWarehouse = state =>
  state.documents.chosenLocationInWarehouse;

export const selectSecondChosenLocationInWarehouse = state =>
  state.documents.secondChosenLocationInWarehouse;

export const selectChosenPeriod = state => state.documents.chosenPeriod;

export const selectSearchQuery = state => state.documents.searchQuery;

export const selectOrdersList = state => state.documents.ordersList;

export const selectPaymentsReturnBasis = state => state.documents.paymentsReturnBasis;

export const selectLocationByPart = state => state.documents.locationsByPartId;

export const selectSelectedLocationIds = createSelector(
  [selectLocationByPart],
  locationsByPartId => Object.values(locationsByPartId)
);

export const selectSalesList = state => state.documents.salesList;

export const selectSaleListLoading = state => state.documents.saleListLoading;

export const selectSale = state => state.documents.sale;

export const selectReceives = state => state.documents.receives;

export const selectReturnDoc = state => state.documents.returnDoc;

export const selectReturnReasons = state => state.documents.returnReasons;

export const selectRevaluationDoc = state => state.documents.revaluationDoc;

export const selectWriteOffDoc = state => state.documents.writeOffDoc;

export const selectInventoryDoc = state => state.documents.inventoryDoc;

export const selectGoodsTransferDoc = state => state.documents.goodsTransferDoc;

export const selectDocumentsByType = state =>
  state.documents.documentsByType;

// Loading states

export const selectDocumentsByTypeLoading = state =>
  state.documents.documentsByTypeLoading;

export const selectItemsDocsLoading = state => state.documents.itemsDocsLoading;

export const selectPaymentDocsLoading = state =>
  state.documents.paymentDocsLoading;

export const selectUserCompaniesDataLoading = state =>
  state.documents.userCompaniesDataLoading;

export const selectWriteOffLoading = state => state.documents.writeoffLoading;

export const selectError = state => state.documents.error;

export const selectPartsToDisplayLoading = state =>
  state.documents.partsToDisplayLoading;

export const selectOrdersListLoading = state =>
  state.documents.ordersListLoading;

export const selectReturnDocLoading = state => state.documents.returnDocLoading;

export const selectReturnPaymentsInfoLoading = state =>
  state.documents.returnPaymentsInfoLoading;

export const selectReceiveLoading = state => state.documents.receiveLoading;
